import React from "react";
import EmployeeList from "../../components/admin/EmployeeList";

const EmployeePage = () => {
  return (
    <div>
      <EmployeeList />
    </div>
  );
};

export default EmployeePage;
